import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('ShareCircleIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="connect__icon icon icon__share-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path className="foreground" d="M81.75,45.49H49A5.48,5.48,0,0,0,43.49,51V72.82A5.48,5.48,0,0,0,49,78.28h8.2L68.09,89.22V78.28H81.75a5.48,5.48,0,0,0,5.47-5.47V51A5.48,5.48,0,0,0,81.75,45.49Z"/>
        <path className="background" d="M57.88,69.55h1.44A12.19,12.19,0,0,1,71.38,59.44h.72l-2.6,2.67a.7.7,0,0,0,0,1l0,0a.7.7,0,0,0,1,0l0,0,4.26-4.4-4.26-4.4a.7.7,0,0,0-1,0l0,0a.7.7,0,0,0,0,1l0,0,2.6,2.6h-.65A13.89,13.89,0,0,0,57.88,69.55Z"/>
      </svg>
    ), el);
  });
};
